import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export interface ShowFiltersTextProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    children: JSX.Element | string
    variant?: string
    component?: string
    disabled?: boolean
    $isSecondary?: boolean
    $isclipped?: boolean
    row?: boolean
    childtestid?: string
}

const ShowFiltersText = memo(
    ({
        templating,
        children,
        variant,
        component,
        disabled,
        $isSecondary,
        $isclipped,
        row,
        childtestid,
    }: ShowFiltersTextProps) => {
        const ComponentName = useTemplatedComponent(templating, MANIFEST)

        return (
            <Suspense>
                <ComponentName
                    variant={variant}
                    component={component}
                    disabled={disabled}
                    $isSecondary={$isSecondary}
                    $isclipped={$isclipped}
                    row={row}
                    data-testid={childtestid}
                >
                    {children}
                </ComponentName>
            </Suspense>
        )
    },
)
ShowFiltersText.displayName = "ShowFiltersText"

export default connect(ShowFiltersText)
